import { render, staticRenderFns } from "./CollectInfo.vue?vue&type=template&id=ca7d4820&scoped=true&"
import script from "./CollectInfo.vue?vue&type=script&lang=ts&"
export * from "./CollectInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CollectInfo.vue?vue&type=style&index=0&id=ca7d4820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d4820",
  null
  
)

export default component.exports